import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

const Lines = ({ styles, count = 2 }) => (
  <View>
    {Array.from({ length: count }).map((_, i) => (
      <View key={i} style={{...styles.line, marginBottom: 5}} />
    ))}
  </View>
);

const CardSet = ({ styles }) => (
  <View style={styles.row}>
    <View style={{...styles.col, gap:5}}>
      <Text style={styles.ButtonTextSmall}>Investment</Text>
      <Lines styles={styles} count={7} />
    </View>

    <View style={{...styles.col, gap:5}}>
      <Text style={styles.ButtonTextSmall}>Certificate Number</Text>
      <Lines styles={styles} count={7} />
    </View>
  </View>
);

const Investments = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
        <Text style={styles.ContentSemiBold}>Investments</Text>
        <Text style={styles.ButtonTextSmall}>
          I have the following investments (e.g. shares, unit-trusts, premium
          bonds etc.)
        </Text>
      <View style={styles.panel}>
        <View style={styles.row}>
          <CardSet styles={styles} />
          <CardSet styles={styles} />
        </View>
      </View>
    </View>
  );
};

export default Investments;
